<template>
  <div>
    <loading
      v-model:active="loading"
      :is-full-page="false"
    />
    <form
      id="loginForm"
      ref="loginForm"
      @submit.prevent="handleLogin"
    >
      <div class="mb-4">
        <label
          class="block font-bold mb-2 text-gray-400 text-sm"
          for="loginForm__email"
        >{{ $t('layout.account.email') }}</label>
        <input
          id="loginForm__email"
          ref="loginForm__email"
          v-model="loginForm.email"
          name="loginForm__email"
          type="email"
          :placeholder="$t('layout.account.email')"
          required
        >
      </div>
      <div class="mb-4">
        <label
          class="block font-bold mb-2 text-gray-400 text-sm"
          for="loginForm__password"
        >{{ $t('layout.account.password') }}</label>
        <input
          id="loginForm__password"
          ref="loginForm__password"
          v-model="loginForm.password"
          name="loginForm__password"
          type="password"
          placeholder="******************"
          required
          minlength="6"
          @keyup.enter="handleLogin"
        >
      </div>
      <button
        class="btn btn__fitMode w-full"
        @click.prevent="handleLogin"
      >
        {{ $t('layout.account.connect') }}
      </button>
    </form>
    <div class="border-b border-gray-100 flex items-center justify-between pb-4 pt-2">
      <GoogleSignin class="w-full" />
    </div>
    <ul>
      <li class="pt-4">
        <button
          class="btnLink--fitMode"
          @click="showModal('createAccount')"
        >
          {{ $t('layout.account.createAccount') }}
        </button>
      </li>
      <li class="m-0 pt-2">
        <button
          class="btnLink--fitMode"
          @click="showModal('passwordForgot')"
        >
          {{ $t('layout.account.passwordForgot.link') }}
        </button>
      </li>
      <li class="m-0 pt-2">
        <router-link
          class="btnLink--fitMode"
          :to="{ name: 'Policy'}"
        >
          {{ $t("pages.policy.title") }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapActions } from 'vuex';

const GoogleSignin = defineAsyncComponent(() => import('@/components/user/UserAuthSocialGoogle'));

export default {
  name: 'UserAuthLogin',

  components: {
    GoogleSignin,
  },

  data() {
    return {
      loginForm: {
        email: '',
        password: ''
      },

      loading: undefined
    };
  },

  methods: {
    handleLogin() {
      this.loading = true;
      this.$store
        .dispatch('user/login', this.loginForm)
        .finally(() => {
          this.loading = undefined;
        });
    },

    focusFirstElement() {
      this.$forceNextTick(() => {
        if (this.loginForm.email === '') {
          this.$refs.loginForm__email.focus();
        } else if (this.loginForm.password === '') {
          this.$refs.loginForm__password.focus();
        }
      });
    },

    ...mapActions('app', ['showModal'])
  }
};
</script>
